import { SortDirection } from '@/ui/types';
import { h, defineComponent } from 'vue';

interface SortingIconProps {
  field: string;
  sort: string;
  direction: SortDirection;
  classes?: string;
}

export const SortingIcon = defineComponent<SortingIconProps>({
  name: 'SortingIcon',
  props: ['field', 'sort', 'direction', 'classes'],

  setup(props) {
    return function render() {
      return props.field === props.sort ? h('span', { class: 'icon sort-icon is-small' }, [
        h('font-awesome-icon', {
          props: {
            class: props.classes ? props.classes : '',
            icon: [
              'far',
              props.direction === SortDirection.Ascending ? 'angle-up' : 'angle-down',
            ],
          },
        }, []),
      ]) : null;
    };
  },
});
